import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { MeetingSelector } from './components/MeetingSelector';
import { LookInsideSection } from './components/LookInsideSection';
import { SolutionSection } from './components/SolutionSection';
import { YearPlanSection } from './components/YearPlanSection';
import { MeetingsList } from './components/MeetingsList';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="38kgm0fx05yr3">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="nvj35ett6cp7" />}
      <TopBar data-id="element-2" data-mp="nvasltl5rjh6" />
      <main data-id="element-3" data-mp="nxwvvh10nctl">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="sunf2d84aoj8" />
        <StatsBand data-id="element-5" data-mp="stc6m03q8sls" />
        <MeetingSelector data-id="element-6" data-mp="ssssyvl40qdk" />
        <LookInsideSection pageImages={pageImages} data-id="element-7" data-mp="36hw15qrsq0p" />
        <SolutionSection data-id="element-8" data-mp="34x1vh8db93d" />
        <YearPlanSection data-id="element-9" data-mp="38ktuby5znfz" />
        <MeetingsList data-id="element-10" data-mp="3ud1f186rfma3" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-11" data-mp="3ubrfsfo6881v" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-12" data-mp="3uf5hdlp0gd89" />
        <GuaranteeSection data-id="element-13" data-mp="d3cujon1mqez" />
        <FaqSection data-id="element-14" data-mp="d2l9v8uzid3h" />
        <FinalCta data-id="element-15" data-mp="85l30vqb96bb" />
      </main>
      <Footer data-id="element-16" data-mp="85bcn71csx53" />
      <StickyCta data-id="element-17" data-mp="86w76wno4g2y" />
    </div>;
}